import { render, staticRenderFns } from "./ShareLinkIndex.vue?vue&type=template&id=b3d1abae&scoped=true"
import script from "./ShareLinkIndex.vue?vue&type=script&lang=js"
export * from "./ShareLinkIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d1abae",
  null
  
)

export default component.exports